import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '@store/hooks';
import { APP_ROUTES } from '@config/routes';
import type { ChildrenProps } from '@types';
import LoadingSpinner from './LoadingSpinner';

interface ProtectedRouteProps extends ChildrenProps {}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { isAuthenticated, userProfile, isLoading } = useAppSelector(state => state.auth);
  const location = useLocation();

  if (isLoading) {
    return <LoadingSpinner fullScreen />;
  }

  if (!isAuthenticated) {
    return <Navigate to={APP_ROUTES.LOGIN} replace />;
  }

  // User has Firebase Auth but no Firestore profile — they need to complete
  // registration/onboarding.  Do not redirect if already on the onboarding/plan-selection
  // routes to avoid an infinite redirect loop (those pages are intentionally accessible
  // without a backend profile so they can create it).
  const onboardingPaths = [APP_ROUTES.PLAN_SELECTION, APP_ROUTES.ONBOARDING];
  if (!userProfile && !isLoading && !onboardingPaths.includes(location.pathname)) {
    return <Navigate to={APP_ROUTES.PLAN_SELECTION} replace />;
  }

  return children;
};

export default ProtectedRoute;
